import { actions } from 'react-redux-form';

import { httpGet } from '../../../../utils/api.utils';
import {
    pipInformationFormModel,
    getCircuitPIPInformationDetails,
    getPIPPortSpeed,
    getPIPCarrierQosProfile,
    getPIPVpnName,
    getPIPVoiceCarSpeed,
    getPIPVoiceCar,
    getPIPSiteOfOrigin,
    setPortSpeedLoading,
    setCarrierQosProfileLoading,
    setVpnNameLoading,
    setVoiceCarSpeedLoading,
    setVoiceCarLoading,
    setSiteOfOriginLoading,
} from "../../../../constants/model-reducers/external/inventory/circuit-details/details-view/pip-information.settings";

const defaultState = () => ({
    portSpeedOptions: [],
    carrierQosProfileOptions: [],
    voiceCarOptions: [],
    vpnNameOptions: [],
    voiceCarSpeedOptions: [],
    asnNewOrExistingOptions: [],
    siteOfOriginOptions: [],
    portSpeedPage: 1,
    hasMorePortSpeed: true,
    isPortSpeedLoading: false,
    carrierQOSProfilePage: 1,
    hasMoreCarrierQOSProfile: true,
    isCarrierQOSProfileLoading: false,
    vpnNamePage: 1,
    hasMoreVpnName: true,
    isVpnNameLoading: false,
    voiceCarSpeedPage: 1,
    hasMoreVoiceCarSpeed: true,
    hasMoreVoiceCar: false,
    isVoiceCarLoading:false,
    isVoiceCarSpeedLoading: false,
    siteOfOriginPage: 1,
    hasMoreSiteOfOrigin: true,
    isSiteOfOriginLoading: false,
});

const initialState = defaultState();

export const pipInformationFormInitialState = pipInformationFormModel;

export const pipInformationActions = {
    getCircuitPIPInformationDetails: (model, circuitId) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getCircuitPIPInformationDetails/' + circuitId);
        await dispatch(pipInformationActions.getPIPPortSpeed(1, res?.data?.PortSpeed ? res?.data?.PortSpeedName : ""));
        await dispatch(pipInformationActions.getPIPCarrierQosProfile(1, res?.data?.CarrierQoSProfile ? res?.data?.CarrierQoSProfileName : ""));
        await dispatch(pipInformationActions.getPIPVpnName(1, res?.data?.VpnName ? res?.data?.VpnNameName : ""));
        await dispatch(pipInformationActions.getPIPVoiceCarSpeed(1, res?.data?.VoiceCarSpeed ? res?.data?.VoiceCarSpeedName : ""));
        await dispatch(pipInformationActions.getPIPVoiceCar(res?.data?.VoiceCarSpeed ? res?.data?.VoiceCarName : ""));
        await dispatch(pipInformationActions.getPIPSiteOfOrigin(1, res?.data?.SiteOfOrigin ? res?.data?.SiteOfOriginName : ""));
        dispatch({
            type: getCircuitPIPInformationDetails,
            asnNewOrExistingOptions: res.asnNewOrExistingOptions,
        });

        if (res.data != null && circuitId !== 0) {
            dispatch(actions.change(`${model}.portSpeed`, res.data.PortSpeed ? res.data.PortSpeed.toString() : ""));
            dispatch(actions.change(`${model}.carrierQOSProfile`, res.data.CarrierQoSProfile ? res.data.CarrierQoSProfile.toString() : ""));
            dispatch(actions.change(`${model}.asnNumber`, res.data.AsnNumber ?? ""));
            dispatch(actions.change(`${model}.voiceCAR`, res.data.VoiceCar ? res.data.VoiceCar.toString() : ""));
            dispatch(actions.change(`${model}.routingProtocol`, res.data.RoutingProtocol ?? ""));
            dispatch(actions.change(`${model}.vpnName`, res.data.VpnName ? res.data.VpnName.toString() : ""));
            dispatch(actions.change(`${model}.voiceCARSpeed`, res.data.VoiceCarSpeed ? res.data.VoiceCarSpeed.toString() : ""));
            dispatch(actions.change(`${model}.asnNewOrExisting`, res.data.ASN_NewOrExisting ?? ""));
            dispatch(actions.change(`${model}.siteOfOrigin`, res.data.SiteOfOrigin ? res.data.SiteOfOrigin.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.portSpeed', res.data.PortSpeed ? res.data.PortSpeed.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.carrierQOSProfile', res.data.CarrierQoSProfile ? res.data.CarrierQoSProfile.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.asnNumber', res.data.AsnNumber ?? ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.voiceCAR', res.data.VoiceCar ? res.data.VoiceCar.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.routingProtocol', res.data.RoutingProtocol ?? ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.vpnName', res.data.VpnName ? res.data.VpnName.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.voiceCARSpeed', res.data.VoiceCarSpeed ? res.data.VoiceCarSpeed.toString() : ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.asnNewOrExisting', res.data.ASN_NewOrExisting ?? ""));
            dispatch(actions.load('inventoryCircuitForm.pipInformation.siteOfOrigin', res.data.SiteOfOrigin ? res.data.SiteOfOrigin.toString() : ""));

        }
        else {
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.portSpeed'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.carrierQOSProfile'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.asnNumber'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.voiceCAR'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.routingProtocol'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.vpnName'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.voiceCARSpeed'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.asnNewOrExisting'));
            dispatch(actions.reset('inventoryCircuitForm.pipInformation.siteOfOrigin'));
        }
    },

    getOrderCircuitPIPInformationDetails: (model, orderId, requestTypeId, orderCircuitDetailId = 0) => async (dispatch, state) => {
        var res = await httpGet('external/order/getOrderCircuitPIPInformationDetails/' + orderId + '/' + requestTypeId + '/' + orderCircuitDetailId);
        await dispatch(pipInformationActions.getPIPPortSpeed(1, res?.data?.PortSpeed ? res?.data?.PortSpeedName : ""));
        await dispatch(pipInformationActions.getPIPCarrierQosProfile(1, res?.data?.CarrierQoSProfile ? res?.data?.CarrierQoSProfileName : ""));
        await dispatch(pipInformationActions.getPIPVpnName(1, res?.data?.VpnName ? res?.data?.VpnNameName : ""));
        await dispatch(pipInformationActions.getPIPVoiceCarSpeed(1, res?.data?.VoiceCarSpeed ? res?.data?.VoiceCarSpeedName : ""));
        await dispatch(pipInformationActions.getPIPVoiceCar(res?.data?.VoiceCarSpeed ? res?.data?.VoiceCarName : ""));
        await dispatch(pipInformationActions.getPIPSiteOfOrigin(1, res?.data?.SiteOfOrigin ? res?.data?.SiteOfOriginName : ""));
        dispatch({
            type: getCircuitPIPInformationDetails,
            asnNewOrExistingOptions: res.asnNewOrExistingOptions,
        });

        if (res.data != null) {
            dispatch(actions.change(`${model}.portSpeed`, res.data.PortSpeed ? res.data.PortSpeed.toString() : ""));
            dispatch(actions.change(`${model}.carrierQOSProfile`, res.data.CarrierQoSProfile ? res.data.CarrierQoSProfile.toString() : ""));
            dispatch(actions.change(`${model}.asnNumber`, res.data.AsnNumber ?? ""));
            dispatch(actions.change(`${model}.voiceCAR`, res.data.VoiceCar ? res.data.VoiceCar.toString() : ""));
            dispatch(actions.change(`${model}.routingProtocol`, res.data.RoutingProtocol ?? ""));
            dispatch(actions.change(`${model}.vpnName`, res.data.VpnName ? res.data.VpnName.toString() : ""));
            dispatch(actions.change(`${model}.voiceCARSpeed`, res.data.VoiceCarSpeed ? res.data.VoiceCarSpeed.toString() : ""));
            dispatch(actions.change(`${model}.asnNewOrExisting`, res.data.ASN_NewOrExisting ?? ""));
            dispatch(actions.change(`${model}.siteOfOrigin`, res.data.SiteOfOrigin ? res.data.SiteOfOrigin.toString() : ""));
        }
    },

    getPIPPortSpeed: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setPortSpeedLoading,
            payload: true
        });

        let url = `external/inventory/getPIPPortSpeed/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getPIPPortSpeed,
                    payload: {
                        portSpeed: res,
                        portSpeedPage: page
                    }
                });
                dispatch({
                    type: setPortSpeedLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setPortSpeedLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setPortSpeedLoading,
                payload: false
            });
        }
    },

    getPIPCarrierQosProfile: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setCarrierQosProfileLoading,
            payload: true
        });

        let url = `external/inventory/getPIPCarrierQosProfile/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getPIPCarrierQosProfile,
                    payload: {
                        carrierQosProfile: res,
                        carrierQOSProfilePage: page
                    }
                });
                dispatch({
                    type: setCarrierQosProfileLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setCarrierQosProfileLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setCarrierQosProfileLoading,
                payload: false
            });
        }
    },

    getPIPVpnName: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setVpnNameLoading,
            payload: true
        });

        let url = `external/inventory/getPIPVpnName/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getPIPVpnName,
                    payload: {
                        vpnName: res,
                        vpnNamePage: page
                    }
                });
                dispatch({
                    type: setVpnNameLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setVpnNameLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setVpnNameLoading,
                payload: false
            });
        }
    },

    getPIPVoiceCarSpeed: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setVoiceCarSpeedLoading,
            payload: true
        });

        let url = `external/inventory/getPIPVoiceCarSpeed/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getPIPVoiceCarSpeed,
                    payload: {
                        voiceCarSpeed: res,
                        voiceCarSpeedPage: page
                    }
                });
                dispatch({
                    type: setVoiceCarSpeedLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setVoiceCarSpeedLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setVoiceCarSpeedLoading,
                payload: false
            });
        }
    },
    getPIPVoiceCar: (searchString = '') => async (dispatch, state) => {
        dispatch({
            type: setVoiceCarLoading,
            payload: true
        });

        let url = `external/inventory/getYesNoOptions/`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getPIPVoiceCar,
                    payload: {
                        voiceCar: res
                    }
                });
            }
        } catch (err) {
            dispatch({
                type: setVoiceCarLoading,
                payload: false
            });
        } finally {
            dispatch({
                type: setVoiceCarLoading,
                payload: false
            });
        }
    },
    getPIPSiteOfOrigin: (page = 1, searchString = '') => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({
            type: setSiteOfOriginLoading,
            payload: true
        });

        let url = `external/inventory/getPIPSiteOfOrigin/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getPIPSiteOfOrigin,
                    payload: {
                        siteOfOrigin: res,
                        siteOfOriginPage: page
                    }
                });
                dispatch({
                    type: setSiteOfOriginLoading,
                    payload: false
                });
            } else {
                dispatch({
                    type: setSiteOfOriginLoading,
                    payload: false
                });
            }
        } catch (err) {
            dispatch({
                type: setSiteOfOriginLoading,
                payload: false
            });
        }
    },
    changeFormModel: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value ?? ""));
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitPIPInformationDetails:
            return {
                ...state,
                asnNewOrExistingOptions: action.asnNewOrExistingOptions,
            };
        case getPIPPortSpeed:
            const { portSpeed, portSpeedPage } = action.payload;
            return {
                ...state,
                portSpeedOptions: portSpeedPage === 1 ? portSpeed : [...state.portSpeedOptions, ...portSpeed],
                hasMorePortSpeed: portSpeed.length > 0,
                portSpeedPage: portSpeedPage
            };
        case setPortSpeedLoading:
            return {
                ...state,
                isPortSpeedLoading: action.payload
            }
        case getPIPCarrierQosProfile:
            const { carrierQosProfile, carrierQOSProfilePage } = action.payload;
            return {
                ...state,
                carrierQosProfileOptions: carrierQOSProfilePage === 1 ? carrierQosProfile : [...state.carrierQosProfileOptions, ...carrierQosProfile],
                hasMoreCarrierQOSProfile: carrierQosProfile.length > 0,
                carrierQOSProfilePage: carrierQOSProfilePage
            };
        case setCarrierQosProfileLoading:
            return {
                ...state,
                isCarrierQOSProfileLoading: action.payload
            }
        case getPIPVpnName:
            const { vpnName, vpnNamePage } = action.payload;
            return {
                ...state,
                vpnNameOptions: vpnNamePage === 1 ? vpnName : [...state.vpnNameOptions, ...vpnName],
                hasMoreVpnName: vpnName.length > 0,
                vpnNamePage: vpnNamePage
            };
        case setVpnNameLoading:
            return {
                ...state,
                isVpnNameLoading: action.payload
            }
        case getPIPVoiceCarSpeed:
            const { voiceCarSpeed, voiceCarSpeedPage } = action.payload;
            return {
                ...state,
                voiceCarSpeedOptions: voiceCarSpeedPage === 1 ? voiceCarSpeed : [...state.voiceCarSpeedOptions, ...voiceCarSpeed],
                hasMoreVoiceCarSpeed: voiceCarSpeed.length > 0,
                voiceCarSpeedPage: voiceCarSpeedPage
            };
        case setVoiceCarSpeedLoading:
            return {
                ...state,
                isVoiceCarSpeedLoading: action.payload
            }
        case getPIPVoiceCar:
            const { voiceCar } = action.payload;
            return {
                ...state,
                voiceCarOptions: voiceCar, 
                hasMoreVoiceCar: false   
            };

        case setVoiceCarLoading:
            return {
                ...state,
                isVoiceCarLoading: action.payload
            };
        case getPIPSiteOfOrigin:
            const { siteOfOrigin, siteOfOriginPage } = action.payload;
            return {
                ...state,
                siteOfOriginOptions: siteOfOriginPage === 1 ? siteOfOrigin : [...state.siteOfOriginOptions, ...siteOfOrigin],
                hasMoreSiteOfOrigin: siteOfOrigin.length > 0,
                siteOfOriginPage: siteOfOriginPage
            };
        case setSiteOfOriginLoading:
            return {
                ...state,
                isSiteOfOriginLoading: action.payload
            }
        default:
            return state;
    }
};  